import { routes } from '@/routing/routes';
import { Location, matchRoutes } from 'react-router-dom';

export const getMatchedPath = (location: Location) => {
  const matches = matchRoutes(routes, location);

  return matches !== null && matches.length > 0 ? matches[0].route.path : undefined;
};
